/**
 * Governor permission helpers (PRD 4.34.0).
 * Admin always has full access; governors use governorPermissions from profile.
 * Default-deny until the permission map is hydrated (least-privilege).
 */

import { useAuth } from '../contexts/AuthContext.jsx';

/**
 * @param {string} key — permission key from governor-permissions.js
 * @returns {boolean}
 */
export function useGovernorPermission(key) {
  const { user } = useAuth();
  if (!user) return false;
  if (user.type === 'admin') return true;
  if (user.type !== 'gouverneur') return false;
  const perms = user.governorPermissions;
  if (!perms || typeof perms !== 'object') return false;
  return perms[key] === true;
}

/**
 * @returns {boolean}
 */
export function useHasAnyGovernorPermission() {
  const { user } = useAuth();
  if (!user) return false;
  if (user.type === 'admin') return true;
  if (user.type !== 'gouverneur') return false;
  const perms = user.governorPermissions;
  if (!perms || typeof perms !== 'object') return false;
  return Object.values(perms).some((v) => v === true);
}

/**
 * Imperative check (non-hook) for event handlers.
 * @param {object|null} user
 * @param {string} key
 */
export function hasGovernorPermission(user, key) {
  if (!user) return false;
  if (user.type === 'admin') return true;
  if (user.type !== 'gouverneur') return false;
  const perms = user.governorPermissions;
  if (!perms || typeof perms !== 'object') return false;
  return perms[key] === true;
}
